import { render, staticRenderFns } from "./PostShortArticle.vue?vue&type=template&id=dbd8e6b8&"
import script from "./PostShortArticle.vue?vue&type=script&lang=js&"
export * from "./PostShortArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports